import { Component, Type, Input, ViewChild, EnvironmentInjector, ViewContainerRef, OnInit, Injector, EventEmitter, Output, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs';

import { FieldFactoryLocator } from '@core/custom-forms/factories/field-factory-locator';
import { FieldFactory } from '@core/custom-forms/factories/field-factory.interface';

import { FieldSubmissionValueInterface, FieldSubmissionValidity } from '@core/custom-forms/models/submissions/submissions-custom-form-field-data.model';

import { CustomFormFieldSubmission, FieldFilterAssociation } from '@core/objects/form';

@Component({
  selector: 'custom-forms-dynamic-fill-field-host',
  template: '<ng-template #dynamicFillFieldContainer></ng-template>'
})
export class DynamicFillFieldHostComponent implements OnInit, OnChanges, OnDestroy {
    @Input() fieldSubmission: CustomFormFieldSubmission;

    @Input() dynamicFieldValues: Array<FieldFilterAssociation>;
    @Output() fieldValueChange = new EventEmitter<FieldSubmissionValueInterface>();
    @Output() fieldValidityChange = new EventEmitter<FieldSubmissionValidity>();
    @ViewChild('dynamicFillFieldContainer', { read: ViewContainerRef, static: true }) dynamicFillFieldContainer: ViewContainerRef;
  
    // protected fieldDataInstance: SettingsCustomFormFieldData; 
    protected componentType: Type<any>; 
    protected componentRef: any;
    constructor(public viewContainerRef: ViewContainerRef,private injector: Injector, 
      private fieldLocator: FieldFactoryLocator,
      private environmentInjector: EnvironmentInjector) {}
  
    ngOnInit() {
      this.loadComponent();
    }

    ngOnChanges(changes: SimpleChanges) {

      if (changes.dynamicFieldValues && !changes.dynamicFieldValues.isFirstChange()) {

            this.dynamicFillFieldContainer.clear();
            this.loadComponent();
              
        }
    }

    ngOnDestroy(): void {
        // Clean up the created component and instance
        // this.fieldDataInstance = null;
        this.componentType = null;
    }

    private loadComponent() {
      const fieldFactory: FieldFactory = this.fieldLocator.get(this.fieldSubmission.field.type);
      // this.fieldDataInstance = fieldFactory.createFillFormFieldData(this.fieldSubmission.field); 
      this.componentType  = fieldFactory.getFillComponentType();
      this.componentRef = this.dynamicFillFieldContainer.createComponent(this.componentType, {
        injector: this.injector,
        environmentInjector: this.environmentInjector
      });
      
      this.updateField();
        // Listen to changes from the component and emit them
      (this.componentRef.instance as any).fieldValueChange.subscribe((updatedValue: FieldSubmissionValueInterface) => {
        this.fieldValueChange.emit(updatedValue);
      });
      (this.componentRef.instance as any).fieldValidityChange.subscribe((validity: FieldSubmissionValidity) => {
        this.fieldValidityChange.emit(validity);
      });
    }

    updateField() {
        if (this.componentRef) {
            (this.componentRef.instance as any).fieldSubmission = {...this.fieldSubmission};
            this.updateDepencencies();
        }
    }

    updateDepencencies() {
        if(this.fieldSubmission.field.type === 'artwork-link-selector-v1'){
            (this.componentRef.instance as any).dynamicFieldValues = [...this.dynamicFieldValues];
        }
    }
}